import type { ReactElement } from 'react';
import type { VendorDirectoryEntry } from '../../domain/types';
import { ActivityTable } from '../activity/ActivityTable';

interface VendorDetailSidePanelProps {
  vendor: VendorDirectoryEntry;
  onClose: () => void;
}

export function VendorDetailSidePanel({ vendor, onClose }: VendorDetailSidePanelProps): ReactElement {
  return (
    <aside className="side-panel" aria-label="Vendor details">
      <div className="side-panel-header">
        <div className="side-panel-title-row">
          <h3>{vendor.name}</h3>
        </div>
        <div className="side-panel-actions">
          <button type="button" className="icon-close" onClick={onClose} aria-label="Close panel">
            ×
          </button>
        </div>
      </div>
      <div className="side-panel-body">
        <dl className="detail-list">
          <dt>Name</dt>
          <dd>{vendor.name}</dd>
          <dt>Email</dt>
          <dd>
            {vendor.email?.trim() ? (
              <a href={`mailto:${encodeURIComponent(vendor.email.trim())}`}>{vendor.email.trim()}</a>
            ) : (
              <span className="hint">—</span>
            )}
          </dd>
          <dt>Address</dt>
          <dd className="multiline">{vendor.address}</dd>
          <dt>Record ID</dt>
          <dd className="mono-id">{vendor.id}</dd>
        </dl>
        <ActivityTable testId="vendor-activity" rows={[]} />
      </div>
    </aside>
  );
}
